import WorkSchedulesView  from '../WorkSchedulesView.vue'
import WorkScheduleList   from '../Pages/WorkScheduleList.vue'
import WorkScheduleEditor from '../Pages/WorkScheduleEditor.vue'

const routes = [
  {
    path: '/mantenimiento/horarios',
    component: WorkSchedulesView,
    children: [
      { path: '',           name: 'work-schedule-list',   component: WorkScheduleList   },
      { path: 'crear',      name: 'work-schedule-create', component: WorkScheduleEditor },
      { path: ':id/editar', name: 'work-schedule-edit',   component: WorkScheduleEditor },
    ],
  },
]

export default routes
